import { createClient, type SupabaseClient } from '@supabase/supabase-js';

// The project's own Supabase — public client values, safe to embed.
const url = __SUPABASE_URL__;
const anon = __SUPABASE_ANON_KEY__;

// Graceful "not configured" state if the backend isn't provisioned yet.
export const isSupabaseConfigured = Boolean(url && anon);

export const supabase: SupabaseClient | null = isSupabaseConfigured
  ? createClient(url, anon, { auth: { persistSession: false } })
  : null;
